import React from 'react';
import './styles.scss';

const Footer = ({
    footerType,
    backButtonText,
    backToPartners,
    backButtonScreen,
    forwardButtonText,
    forwardButtonScreen,
    changeScreen,
    aboveFooterText,
    aboveFooterTextSize,
    isForwardButtonEnable,
    currentQuestion,
    buttonText,
    selectedAnswer,
}) => {
    const footerWrapperClass = footerType ? 'footerWrapper ' + footerType : 'footerWrapper';
    const footerTextClass = aboveFooterTextSize ? 'footerText ' + aboveFooterTextSize : 'footerText';

    return (
        <div className={footerWrapperClass}>
            {currentQuestion !== 4 && (
                <p className={footerTextClass} dangerouslySetInnerHTML={{ __html: aboveFooterText }} />
            )}
            {currentQuestion === 4 &&
                (selectedAnswer[currentQuestion]?.text === '' ||
                    selectedAnswer[currentQuestion]?.text === 'Select Eligibility Criteria') && (
                    <p className={footerTextClass} dangerouslySetInnerHTML={{ __html: aboveFooterText }} />
                )}

            <div className='footer'>
                {isForwardButtonEnable && forwardButtonText ? (
                    <button
                        className='button continue'
                        onClick={() => {
                            changeScreen(forwardButtonScreen);
                        }}
                    >
                        {forwardButtonText}
                    </button>
                ) : (
                    currentQuestion > 3 &&
                    forwardButtonText && (
                        <button
                            className='button continue'
                            onClick={() => {
                                changeScreen(forwardButtonScreen);
                            }}
                        >
                            {forwardButtonText}
                        </button>
                    )
                )}

                {buttonText && forwardButtonScreen === 'submit' ? (
                    <a
                        className='button continue submit'
                        href='https://www.ncl.ac.uk/partners/how-to-apply/'
                    >
                        {buttonText}
                    </a>
                ) : (
                    buttonText && (
                        <button
                            className='button continue'
                            onClick={() => {
                                changeScreen(forwardButtonScreen);
                            }}
                        >
                            {buttonText}
                        </button>
                    )
                )}

                {currentQuestion === 1 ? (
                    <p className='hidden'>_</p>
                ) : backButtonText && backButtonScreen ? (
                    <button
                        className='button back'
                        onClick={() => {
                            changeScreen(backButtonScreen);
                        }}
                    >
                        {backButtonText}
                    </button>
                ) : (
                    <p className='hidden'>_</p>
                )}
            </div>
        </div>
    );
};

export default Footer;
